export default __webpack_public_path__ + "static/media/mobileLogo.21ec15a5.svg";